module.exports = __webpack_public_path__ + "static/media/icon_myedite.24dc8ea8.svg";